<div class="right-panel">
  <div class="panel-header">
    <p class="panel-title">Add RF Param Set Element</p>
  </div>
  <div class="panel-container">
    <form name="addRFParamSetElement"
          class="createNS"
          #validate="ngForm"
          action="">
      <div class="createNS-row">
        <label for="paramSetId"
               class="widget-create-title">Param Set ID
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <textarea id="paramSetId"
               size="128"
               rows="3"
               class="widget-create-content form-control"
               [ngClass]="{'paramSetIdUsedError': paramSetIdExist}"
               [(ngModel)]="rfParamSetElement.RFParamSetID"
               name="paramSetId"
               required
               #paramSetIdInput
               maxlength="128"
               #paramSetId="ngModel"
               (input)="validateParamSetId(rfParamSetElement.RFParamSetID, paramSetIdInput)"
               (keyup)="trimValue($event)"
               autocomplete="off"></textarea>
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <!--Errors-->
        <div *ngIf="paramSetId.invalid && (paramSetId.dirty || paramSetId.touched)"
             class="alert alert-danger alert-validate">
          <div [hidden]="!paramSetId.hasError('required')">Param Set ID is required</div>
        </div>

        <div *ngIf="paramSetIdExist"
             class="alert alert-danger alert-validate">Param Set ID already exists!
        </div>
      </div>

      <div class="createNS-row">
        <label for="actilityRfParamSet"
          class="widget-create-title">Actility RF ParamSet
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input type="file" id="actilityRfParamSet"
               class="widget-create-content form-control"
               name="actilityRfParamSet"
               required
               #actilityRfParamSetInput
               (change)="fileChangeEvent($event)"/>
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
        <!--Errors-->

      </div>

      <div class="btn-area">
        <button (click)="backClicked()"
                class="custom-btn">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                [disabled]="paramSetIdExist || !rfParamSetElement.isValid()"
                (click)="addRFParamSetElement()">Save
        </button>
      </div>
    </form>
  </div>
</div>
